var _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666504 28.3332L6.8665 10.9999L18.0998 22.0999L0.666504 28.3332ZM4.03317 24.9666L14.4998 21.2332L7.73317 14.4332L4.03317 24.9666ZM16.5665 16.1666L15.4332 15.0332L23.4332 7.03322C24.1443 6.32211 25.0443 5.961 26.1332 5.94989C27.2221 5.93878 28.1221 6.28877 28.8332 6.99989L29.3998 7.56655L28.2665 8.69989L27.6332 8.06655C27.2109 7.64433 26.7221 7.42766 26.1665 7.41655C25.6109 7.40544 25.1109 7.62211 24.6665 8.06655L16.5665 16.1666ZM11.2665 10.9999L10.1332 9.86655L11.1332 8.86655C11.6443 8.35544 11.8832 7.77211 11.8498 7.11655C11.8165 6.461 11.5776 5.911 11.1332 5.46655L10.1998 4.53322L11.3332 3.39989L12.1998 4.26655C12.9776 5.04433 13.3609 6.01655 13.3498 7.18322C13.3387 8.34989 12.9443 9.32211 12.1665 10.0999L11.2665 10.9999ZM13.9665 13.5666L12.8332 12.4332L17.8998 7.36655C18.3221 6.94433 18.5276 6.40544 18.5165 5.74989C18.5054 5.09433 18.2887 4.55544 17.8665 4.13322L15.8332 2.09989L16.9665 0.966553L19.0665 3.06655C19.7554 3.77766 20.1109 4.67211 20.1332 5.74989C20.1554 6.82766 19.8109 7.72211 19.0998 8.43322L13.9665 13.5666ZM19.2332 18.8666L18.0998 17.7332L19.6665 16.1666C20.4443 15.3888 21.3776 14.9888 22.4665 14.9666C23.5554 14.9443 24.4887 15.3221 25.2665 16.0999L26.9665 17.7999L25.8332 18.9332L24.0998 17.1999C23.5887 16.6888 23.0554 16.4332 22.4998 16.4332C21.9443 16.4332 21.4109 16.6888 20.8998 17.1999L19.2332 18.8666Z",
    fill: "url(#paint0_linear_10731_2490)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10731_2490",
    x1: 29.3998,
    y1: 0.966553,
    x2: 0.666504,
    y2: 0.966553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006ad9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55a6fb"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent);
export default __webpack_public_path__ + "static/media/event.1b75e0fb3f2bad3cc8c0dc0a9924a25c.svg";
export { ForwardRef as ReactComponent };